export default __webpack_public_path__ + "/src/assets/images/ec3-tooltip-graph-v3.png";